<template>
  <transition name="fader">
    <div class="information-ballon" :class="direction" v-if="open" v-show="open">
      <div :class="{
        'seta-baixo': direction == 'down',
        'seta-direita': direction == 'right'
      }"></div>
      <span>{{ text }}</span>
      <button class="b-close-slot" @click="close" >
        <i><font-awesome-icon icon="times" /></i>
      </button>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'InformationBallon',
  props: {
    text: String, // As NCMs selecionadas por último passarão a ser exibidas primeiro
    alias: String, // tour-new-interface-order-ncm
    direction: String, // down
  },
  data() {
    return {
      open: false,
    }
  },
  created() {
    // console.log('create getAvisosOrFalse', this.getAvisosOrFalse)
    // this.foundAviso()
  },
  async mounted() {
    // console.log('mounted getAvisosOrFalse', this.getAvisosOrFalse)
    // await this.fetchAvisos()
    // this.foundAviso()
  },
  computed: {
    ...mapGetters('avisos', ['getAvisosOrFalse', 'getAvisos', 'getCountFetch']),
  },
  methods: {
    ...mapActions('avisos', ['fetchAvisos', 'setAvisos']),

    foundAviso: function () {
      if (!this.alias || this.alias == '') { return false }

      const avisosOrFalse = this.getAvisosOrFalse
      if (!avisosOrFalse) {
        this.open = false
        return false
      }

      let found = this.getAvisos.find(a => {
        return a.aviso == this.alias
      })

      if (!found) {
        this.open = true
      } else {
        this.open = false
      }
    },

    close: async function () {
      this.open = false

      await this.setAvisos(this.alias)

      // this.foundAviso()

      this.open = false
    },
  },
  watch: {
    getCountFetch: function () {
      this.foundAviso()
    },
  },
}
</script>

<style lang="scss">
.information-ballon {
  width: auto;
  position: absolute;

  &.down {
    top: 40px;
  }

  &.right {
    right: 260px;
    top: 25px;
  }

  opacity: 0.9;

  &:hover {
    opacity: 1;
  }

  color: #0c5460;
  background: #d1ecf1;
  border-radius: 4px;
  padding: 10px 15px;

  border: 1px #095d6c solid;

  display: flex;
  justify-content: center;
  align-items: center;

  button {
    font-weight: bold;
    border-radius: 3px;

    cursor: pointer;
    margin-left: 10px;

    &:hover {
      color: #406a71;
    }
  }

  .seta-baixo:before {
    position: absolute;
    bottom: -10px;
    left: 35px;

    content: "";
    vertical-align: middle;
    margin-right: 10px;
    width: 0;
    height: 0;

    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #095d6c;
  }

  .seta-direita:before {
    position: absolute;
    top: 18px;
    right: -20px;

    content: "";
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
    width: 0;
    height: 0;

    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid #095d6c;
  }

  .fader-enter-active,
  .fader-leave-active {
    transition: opacity 2s;
  }

  .fader-enter,
  .fader-leave-to

  /* .fade-leave-active em versões anteriores a 2.1.8 */
	{
    transition: opacity 2s;
    opacity: 0;
  }
}
</style>
